
import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { PhoneNumber } from "./address.model";

export class Message {

    id = 0;
    businessLine: CarBusinessLine = CarBusinessLine.BUY;
    carId = "";
    offerId = "";
    conversationId = 0;
    senderId = "";
    receiverId = "";
    replyTo = 0;

    senderName = "";
    senderEmail = "";
    senderPhoneNumber: PhoneNumber = new PhoneNumber();

    body = "Hellooo";
    read = false;
    created = "";

    replies: Message[] = [];

    constructor(){
        this.replies = [];
    }
}


